import { TourDialog } from './dialogs/TourDialog';
import { TransferDialog } from './dialogs/TransferDialog';
import { AccomodationDialog } from './dialogs/AccomodationDialog';
import { EventDialog } from './dialogs/EventDialog';
import { ExcursionDialog } from './dialogs/ExcursionDialog';

export default {
    TransferDialog,
    TourDialog,
    AccomodationDialog,
    EventDialog,
    ExcursionDialog
}